import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=432fe6cc&"
import script from "./VersionUpdate.vue?vue&type=script&lang=js&"
export * from "./VersionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports